import { useRef } from 'react'
import { motion, useInView, useReducedMotion } from 'framer-motion'

export function BlurFade({
  children,
  className,
  duration = 0.4,
  delay = 0,
  yOffset = 8,
  blur = '6px',
  inViewMargin = '-50px',
  once = true,
}) {
  const ref = useRef(null)
  const reduce = useReducedMotion()
  const inView = useInView(ref, { once, margin: inViewMargin })

  if (reduce) {
    return (
      <div ref={ref} className={className}>
        {children}
      </div>
    )
  }

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: yOffset, filter: `blur(${blur})` }}
      animate={inView ? { opacity: 1, y: 0, filter: 'blur(0px)' } : {}}
      transition={{ duration, delay: 0.04 + delay, ease: 'easeOut' }}
      className={className}
    >
      {children}
    </motion.div>
  )
}
